export const SCREEN_PADDING = 20;
